var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CrossIcon } from '../icons/cross-icon';
import { DragDropIcon } from '../icons/drag-drop-icon';
import { Text } from '../ui';
export var SubStatusItem = function (_a) {
    var subStage = _a.subStage, isEditing = _a.isEditing, handleSubStageChange = _a.handleSubStageChange, statusId = _a.statusId, setShowDeleteModal = _a.setShowDeleteModal, setDeleteItems = _a.setDeleteItems;
    var _b = useSortable({
        id: subStage.sub_id,
    }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition;
    return (_jsx("div", { ref: setNodeRef, style: { transform: CSS.Transform.toString(transform), transition: transition }, className: 'ml-6 rounded-[10px] py-[6px] px-[10px] border border-[#EEEEEE] transition-all', children: _jsxs("div", { className: 'flex items-center space-x-3 grow', children: [isEditing && (_jsx("div", __assign({}, listeners, attributes, { className: 'cursor-grab p-2', children: _jsx(DragDropIcon, {}) }))), isEditing ? (_jsxs(_Fragment, { children: [_jsx("input", { type: 'text', value: subStage.name, onChange: function (e) { return handleSubStageChange(statusId, subStage.sub_id, e.target.value); }, className: ' p-1 rounded w-full' }), _jsx("button", { className: 'p-2', onClick: function () {
                                setShowDeleteModal(true);
                                setDeleteItems(subStage.sub_id);
                            }, children: _jsx(CrossIcon, {}) })] })) : (_jsx(Text, { variant: 'description', children: subStage.name }))] }) }));
};
